export default {
  computed: {
    btnClass() {
      return {
        "flex justify-center items-center py-2 px-2 border text-sm font-medium rounded-md transition duration-150 ease-in-out focus:ring-indigo-50 focus:outline-none": true,
        "px-3 border-transparent text-white bg-indigo-600 hover:bg-indigo-500 focus:border-indigo-700 active:bg-indigo-700": this.primary,
        "px-3 border-indigo-600 text-indigo-600 hover:bg-transparent hover:border-indigo-400 hover:text-indigo-400 focus:border-indigo-500 focus:outline-none active:border-indigo-500": this.secondary,
        "border-transparent text-white bg-red-600 hover:bg-red-500 focus:border-red-700 active:bg-red-700": this.danger,
        "border-red-600 text-red-600 bg-transparent hover:border-red-400 hover:text-red-400": this.danger && this.secondary,
        "text-indigo-500 bg-transparent border-none hover:text-indigo-400 hover:bg-transparent active:text-indigo-600 active:outline-none focus:text-indigo-600 focus:outline-none": this.icon,
      }
    },
  },
}
